import React, { createContext, useContext, useState, useEffect } from 'react';
import API from '../utils/api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [owner, setOwner] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('ms_token');
    const savedUser = localStorage.getItem('ms_user');
    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
      API.get('/auth/me').then(res => {
        setUser(res.data.user);
        setOwner(res.data.owner);
        localStorage.setItem('ms_user', JSON.stringify(res.data.user));
      }).catch(() => logout());
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const res = await API.post('/auth/login', { email, password });
    if (res.data.requiresOtp) return res.data;
    completeAuth(res.data);
    return res.data;
  };

  const completeAuth = (data) => {
    localStorage.setItem('ms_token', data.token);
    localStorage.setItem('ms_user', JSON.stringify(data.user));
    setUser(data.user);
    setOwner(data.owner);
  };

  const logout = () => {
    localStorage.removeItem('ms_token');
    localStorage.removeItem('ms_user');
    setUser(null);
    setOwner(null);
  };

  return (
    <AuthContext.Provider value={{ user, owner, loading, login, completeAuth, logout, setUser, setOwner }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
